import React from "react";
import {useStyles} from "./DeviceControlMobile.styles";
import {FilterInput} from "../Shared";
import {useEntityFiltering, useEntitySelectedContext} from "../Hooks";
import {shallowEqual, useSelector} from "react-redux";
import {selectEntityForOrgTree} from "../../../state/slices/OrgTree";
import * as c from "../../../constants";
import {EntityDropDown} from "./EntityDropDown";
import _ from "lodash";
import {useFeatureFlag} from "../../../hooks/useFeatureFlags";

export const DeviceControlMobile = () => {
    const classes = useStyles();
    const [filterText, setFilterText] = React.useState('');
    const {associatedEntities, entitySelected} = useEntitySelectedContext();
    const contractNestFeature = useFeatureFlag("Contract Nest");
    const contextID = useSelector(state => state.coreEntities.ContextID, shallowEqual);

    const entity = useSelector((state) => selectEntityForOrgTree(entitySelected)(state), shallowEqual);
    const filteredAssociatedEntities = useEntityFiltering(
        associatedEntities,
        filterText,
        true,
        entity
    )

    const handleFilterChange = (value) => {
        setFilterText(value);
    };

    const filteredAssociatedEntitiesForContractNest = React.useMemo(() => {
        if (!filteredAssociatedEntities) return {};

        const filtered = {};
        Object.entries(filteredAssociatedEntities).forEach(([title, entityData]) => {
            // Filter out the entity group if it matches the condition
            if (entityData.typeID === c.ENTITY_TYPE.Area &&
                entityData.parentID === contextID &&
                !contractNestFeature) {
                return; // Skip this entity group
            }

            // Also filter children within each group
            const filteredChildren = entityData.children.filter(child =>
                !(child.typeid === c.ENTITY_TYPE.Area &&
                    child.parententityid === contextID &&
                    !contractNestFeature)
            );

            filtered[title] = {
                ...entityData,
                children: filteredChildren
            };
        });

        return filtered;
    }, [filteredAssociatedEntities, contextID, contractNestFeature]);

    return (
        <div className={classes.mobileContainer}>
            <div className={classes.filterInputContainer}>
                <FilterInput onChange={handleFilterChange}/>
            </div>
            <div className={classes.entityListContainer}>
                {filteredAssociatedEntitiesForContractNest &&
                    Object.entries(filteredAssociatedEntitiesForContractNest).map(([title, entities]) => {
                        const showEntityDropdown = (entities.children.filter((entity) => entity?.typeid === c.ENTITY_TYPE.Device).length > 0);
                        return (
                            <div key={title}>
                                {showEntityDropdown && (
                                    <EntityDropDown
                                        title={title}
                                        entities={entities.children}
                                        entityID={entities.entityID}
                                        hasChildren={false}
                                    />
                                )}
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};